export enum CompanyConfigType {
  SignupTextLabelTitle = 161,
  SignupTextLabelFirstName = 162,
  SignupTextLabelLastName = 163,
  SignupTextLabelDateOfBirth = 164,
  SignupTextLabelPassword = 165,
  SignupTextLabelEmail = 169,
  SignupTextLabelMobile = 171,
  SignupTextLabelConfirmPassword = 177,
  SignupFieldPasswordRegex = 440,
  SignupFieldPasswordRegexMessage = 441,
  SignupFieldTitleRequiredMessage = 711,
  SignupFieldFirstNameRequiredMessage = 712,
  SignupFieldLastNameRequiredMessage = 713,
  SignupFieldDOBRequiredMessage = 714,
  SignupFieldEmailRequiredMessage = 716,
  SignupFieldEmailRegexRequiredMessage = 717,
  SignupFieldPasswordRequiredMessage = 718,
  SignupFieldConfirmPasswordRequiredMessage = 720,
  SignupFieldConfirmPasswordRegexMessage = 721,
  SignupFieldTermsAndConditionsRequiredMessage = 722,
  SignupFieldMobileValidation = 591,
  SignupFieldDOBValidation = 590,
  SignupHeadingPersonalInfo = 723,
  SignupTitleShowHide = 673,
  SignupHeadingSecurity = 724,
  SignupPageTitle = 725,
  SignupSubmitButton = 39,
  SignupEmailCommunicationOpt = 451,
  SelectAppPreOrder = 740,
  SelectAppScanAndGo = 739,
  SelectAppLoyalty = 738,
  SignupMinAgeLimit = 8,
  SignupAutoValidation = 52,
  AnonymousBrowsing = 270,
  ChooseFunctionHeaderImageH = 772,
  ChooseFunctionHeaderImageV = 773,
  ChooseFunctionSlider = 456,
  MyCardsLoyaltyCardsBoolean = 26,
  MyCardsPaymentCardsBoolean = 54,
  SoloFeatureHideLoyaltyCards = 785,
  SoloFeatureHideClickandCollectHistory = 788,
  SoloFeatureHideScanAndGoHistory = 787,
  SoloAllergensPopUpBody2 = 789,
  SoloFeatureHideCheckoutVoucher = 785,
  SoloFeatureAllowAutoTopup = 792,
  MinimumTopup = 55,
  MaximumTopup = 445,
  ShowVouchers = 27,
  ShowPurses = 797,
  ShowDeleteAccount = 798,
  TextForgottenYourPassword = 168,
  TextBasicLogin = 336,
  SoloSignUpRememberMeText = 760,
  SoloSignUpButtonText = 761,
  TextBasicEmailAddress = 159,
  TextHome = 42,
  SoloFunctionMessageText = 781,
  SoloWelcomeLoyaltyMessage = 763,
  SoloLoyaltyQRCodeText = 782,
  TextPurses = 45,
  TextVouchers = 50,
  SoloWelcomeWalletMessage = 764,
  SoloWelcomeVoucherMessage = 765,
  SoloWelcomeActivityMessage = 766,
  TextAbout = 32,
  TextAccountDetails = 35,
  TextFAQ = 40,
  TextSignOut = 47,
  TextTermsandConditions = 49,
  TextPrivacyPolicy = 535,
  SoloScanandGoHistoryText = 767,
  SoloClickandCollectHistoryText = 768,
  SoloChooseLocationText = 741,
  SoloChooseLocationWelcomeMessage = 769,
  SoloCollectionTimeHeading = 770,
  SoloConfirmButtonText = 771,
  TextRequiredCaloriesPerDayForAdults = 710,
  SoloOrderCheckoutHeaderText = 774,
  SoloOrderCheckoutYourOrderText = 775,
  SoloOrderCheckoutNotesText = 776,
  SoloOrderCheckoutPaymentText = 777,
  SoloOrderCheckoutVouchersText = 778,
  SoloPaymentSuccessMessageText = 779,
  SoloPaymentHeaderText = 780,
  TextHelpCentreTitle = 230,
  TextYourAccount = 332,
  SoloAllergensPopUpShowHide = 799,
  SoloAllergensPopUpHeader = 800,
  SoloAllergensPopUpBody = 801,
  SoloShowPayByCardMultiPayment = 805,
  AllowPassCreation = 715,
  TextQrCode = 623,
  SoloAccessibilityStatementText = 806,
  SoloAllergenStatementText = 807,
  SoloMyCardsText = 808,
  SoloAccountSettingsText = 809,
  SoloShowTickertape = 810,
  SoloFontFamily = 811,
  SoloAltColourForTextIconOnBackground = 812,
  SoloClickCollectLocationTemplateType = 813,
  SoloFontFamilyUrl = 814,
  SoloCheckoutAsGuestSharedAccountId = 704,
  SoloMenuMode = 816,
  SoloFavouriteWalletText = 817,
  SoloFavouriteVoucherText = 818,
  SoloFavouriteLocationText = 819,
  SoloHomeRecentOrderText = 820,
  SoloShowCalorieText = 786,
  SoloCheckoutCollectOrderText = 815,
  AllowClickAndCollect = 73,
  AllowGoogleAndApplePay = 824,
  SoloPayByCardText = 828,
  ChecoutAsGuestAllowAnonymous = 705,
  SoloRestrictedAgeMessageText = 830,
  SoloPaymentScreenDeliverText = 831,
}
